<template>
	<div class="item6">
		<img class="logoico" src="../assets/images/logo.png" />
		<back></back>
		<div class="item6box">
			<div class="title">
				<div>医德篇</div>
			</div>
			<audio :src="mpsurl" ref="audio" preload="auto" @ended="endvideo" type="audio/mpeg">
			</audio>
			<!-- 播放用户录音 -->
			<audio v-if="isshowuserly" :src="lydata" ref="audioly" controls="controls"></audio>
			<div class="content">
				<img class="bagsss" src="../assets/images/item6bag1.png" />
				<div v-if="!isshow" class="contenttext">
					<div style="width: 100%;height: 100%;position: relative;">
						<a class="startbtn" href="javascript:void(0);" @click="playaudio"><img class="startbtn"
								src="../assets/images/startplay.png" /></a>
						<div class="starttxt">点击播放按钮，开始了解《大医精诚》</div>
					</div>
				</div>
				<div v-else class="contenttext">
					<div class="leftssss">
						<!-- 20 -->
						<a ref="left1" style="transform: translateX(-20rem);" href="javascript:void(0);"
							@click="playaudio"><img src="../assets/images/play2.png" />
							</a>

						<template v-if="!recording">
							<!-- 30 -->
							<a ref="left2" @click="soundrecording" style="transform: translateX(-30rem);"
								href="javascript:void(0);"><img src="../assets/images/play3.png" />
								
								</a>
						</template>
						<template v-else>
							<a ref="left2" style="transform: translateX(0);" href="javascript:void(0);"><span
									:class="{'icosss':isshowdd}">
									<img v-if="isshowdd" @click="endrecord" src="../assets/images/playrstop.png" />
									<img v-else src="../assets/images/play3.png" @click="soundrecording" />
									<p class="cl" @click="recodingmy">重录</p>
									<p v-if="lydata!=null" class="bfly" @click="playtherecording">播放录音</p>
									<p v-else class="bfly2">播放录音</p>
								</span></a>
						</template>

							<!-- 40 -->
							<a ref="left3" style="transform: translateX(-40rem);" href="javascript:void(0);"><img
									src="../assets/images/play1.png" /></a>
							<a ref="left4" @click="submit" style="transform: translateX(0);display: none;"
								href="javascript:void(0);"><img src="../assets/images/play4.png" /></a>

					</div>
					<div class="ccccc">
						<img src="../assets/images/borderssss.png" />
						<p class="txtp txtp13">则是含灵巨贼。</p>
						<img src="../assets/images/borderssss.png" />
						<p class="txtp txtp12">心。如此可为苍生大医，反此</p>
						<img src="../assets/images/borderssss.png" />
						<p class="txtp txtp11">，一心赴救，无作功夫形迹之</p>
						<img src="../assets/images/borderssss.png" />
						<p class="txtp txtp10"><span>巇</span>、昼夜、寒暑、饥渴、疲劳</p>
						<img src="../assets/images/borderssss.png" />
						<p class="txtp txtp9">若己有之，深心凄怆。勿避险</p>
						<img src="../assets/images/borderssss.png" />
						<p class="txtp txtp8">吉凶，护惜身命。见彼苦恼，</p>
						<img src="../assets/images/borderssss.png" />
						<p class="txtp txtp7">之想。亦不得瞻前顾后，自虑</p>
						<img src="../assets/images/borderssss.png" />
						<p class="txtp txtp6">夷愚智，普同一等，皆如至亲</p>
						<img src="../assets/images/borderssss.png" />
						<p class="txtp txtp5">富，长幼妍蚩，怨亲善友，华</p>
						<img src="../assets/images/borderssss.png" />
						<p class="txtp txtp4">厄来求救者，不得问其贵贱贫</p>
						<img src="../assets/images/borderssss.png" />
						<p class="txtp txtp3">，誓愿普救含灵之苦。若有疾</p>
						<img src="../assets/images/borderssss.png" />
						<p class="txtp txtp2">无欲无求，先发大慈恻隐之心</p>
						<img src="../assets/images/borderssss.png" />
						<p class="txtp txtp1">凡大医治病，必当安神定志，</p>
						<img src="../assets/images/borderssss.png" />
					</div>
					<div class="rightssss" ref="right" style="opacity: 0;">
						<img class="titlessss" src="../assets/images/dyjc.png" />
					</div>
				</div>
			</div>
		</div>
		<popuptos ref="popuptos" text="录音过程中，请保持麦克风为开启状态！"></popuptos>
		<popup ref="popup" :types="popuptype"  :message="textss"></popup>
		
		<div class="popuptos" v-if="isshowsccc">
			<div class="popubox">
				<div class="poputitle">测评分数</div>
				<div class="poputext">
					{{sccccc}}
				</div>
				<div class="btna">
					<a href="javascript:void(0);" @click="closebubu">确定</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import back from '../components/backhome/back.vue'
	import popup from '../components/popups/popup.vue'
	import mp3 from '../assets/video/MP3.mp3'
	import Recorder from 'js-audio-recorder'
	import popuptos from '../components/popups/popuptos.vue'

	import axios from 'axios'
	export default {
		components: {
			back,
			popuptos,
			popup
		},
		data() {
			return {
				isshowsccc: false,
				token: this.$store.state.token,
				userid: this.$store.state.userid,
				mpsurl: mp3,
				isshow: false,
				recorder: null,
				lydata: null,
				isshowuserly: false, //播放用户录音
				recording: false, //是否录音  默认否
				isshowdd: true, //绿点
				textss: null,
				popuptype: null,
				sccccc: '正在等待语音测评,请不要进行操作'
			}
		},
		created() {
			this.getadmin()
			this.recorder = new Recorder()
			// setTimeout(()=>{
			// 	this.btnclass()
			// },2000)
		},
		beforeDestroy() {
			this.recorder.destroy().then(function() {
			    this.recorder = null
			})
		},
		methods: {
			closebubu(){
				this.isshowsccc = false
				this.sccccc = '正在等待语音测评,请不要进行操作'
			},
			backhomesss(){
				this.$router.replace('/home')
			},
			getadmin(){
				Recorder.getPermission().then(() => {
				}, (error) => {
					alert(`请检查是否有可用的麦克风`)
				})
			},
			playtherecording() { //播放录音
				this.isshowuserly = true
			},
			recodingmy() { //重新开始录音
				if(this.isshowdd){//说明正在录音  先结束 再开始
					this.recorder.stop()
				}
				this.lydata = null
				this.$refs.left3.setAttribute('style', 'display: block')
				this.$refs.left4.setAttribute('style', 'display: none;')
				this.isshowdd = true
				this.recorder.start()
				this.isshowuserly = false
			},
			soundrecording() { //开始录音
				
				this.$refs.popuptos.popuptosshow()
				this.recorder.start()
				this.recording = true
			},
			btnclass() { //三个按钮出现
				this.$refs.left1.setAttribute('style', 'transform: translateX(0)')
				this.$refs.left2.setAttribute('style', 'transform: translateX(0)')
				this.$refs.left3.setAttribute('style', 'transform: translateX(0)')
			},
			endrecord() { //结束录音
				this.recorder.stop()
				let dataArray = this.recorder.getWAVBlob()
				this.lydata = window.URL.createObjectURL(dataArray)
				this.isshowdd = false
				this.$refs.left3.setAttribute('style', 'display: none;')
				this.$refs.left4.setAttribute('style', 'display: block;')
			},
			endvideo() { //播放结束
				this.btnclass()
			},
			playaudio() {
				this.intis()
				this.isshow = true
				this.$refs.audio.play()
				//this.recorder.start()
				setTimeout(() => {
					this.$refs.right.setAttribute('style', 'opacity:1')
				}, 4000)
				setTimeout(() => {
					this.textplay()
				}, 7000)
			},
			intis(){
				let allp = document.getElementsByClassName('txtp')
				for (let i = allp.length - 1; i >= 0; i--) {
					allp[i].setAttribute('style', 'opacity:0')
				}
			},
			textplay() {
				let allp = document.getElementsByClassName('txtp')
				for (let i = allp.length - 1; i >= 0; i--) {
					setTimeout(() => {
						allp[i].setAttribute('style', 'opacity:1')
					}, (allp.length - i - 1) * 4000)
				}
			},
			submit() { //将录音提交到后台接口
				this.isshowsccc = true
				new Promise((resolve, reject) => {
					let forms = new FormData()
					forms.append('file',this.recorder.getPCMBlob())
					forms.append("format","wav")
					axios.post(this.$api.commonUrl + 'attachments/upload', forms, {
						headers: {
							"Authorization": "Bearer " + this.token
						}
					}).then(res => {
						if(res.data.code=='200'){
							resolve(res.data.data.id)
						}else{
							resolve(null)
						}
					})
				}).then((res)=>{
					console.log(res)
					if(res!=null){
						axios({
							url: this.$api.commonUrl + 'ise/evaluation',
							method: 'POST',
							data: {
								"studentId": this.userid,
								"attachmentId": res,
								"text": "凡大医治病，必当安神定志，无欲无求，先发大慈恻隐之心，誓愿普救含灵之苦。若有疾厄来求救者，不得问其贵贱贫富，长幼妍蚩，怨亲善友，华夷愚智，普同一等，皆如至亲之想。亦不得瞻前顾后，自虑吉凶，护惜身命。见彼苦恼，若己有之，深心凄怆。勿避险巇、昼夜、寒暑、饥渴、疲劳，一心赴救，无作功夫形迹之心。如此可为苍生大医，反此则是含灵巨贼。"
							},
							headers: {
								"Authorization": "Bearer " + this.token
							}
						}).then(res => {
							console.log(res)
							if (res.data.code == '200') {
								console.log(res.data.data.score)
								this.sccccc = res.data.data.score + '分'
							}else{
								this.textss = '提交失败'
								this.popuptype = 'error'
								this.$refs.popup.popupshow()
							}
						}).catch(err => {
							console.log("login", err)
						})
					}
				}).catch(err=>{
					console.log(err)
				})
			}
		},
		mounted() {}
	}
</script>

<style scoped>
	.cl {
		position: absolute;
		bottom: -2rem;
		left: -0.2rem;
		font-size: 0.8rem;
		color: #a73a29;
	}

	.bfly2 {
		position: absolute;
		bottom: -2rem;
		right: -0.2rem;
		font-size: 0.8rem;
		color: #848484;
	}

	.bfly {
		position: absolute;
		bottom: -2rem;
		right: -0.2rem;
		font-size: 0.8rem;
		color: #ab7b58;
	}

	.icosss {
		position: relative;
	}

	.icosss::after {
		content: "";
		position: absolute;
		width: 0.7rem;
		height: 0.7rem;
		right: 1.8rem;
		top: 1.8rem;
		background: palegreen;
		z-index: 999;
		border-radius: 50%;
		/* IE10、Firefox and Opera，IE9以及更早的版本不支持 */
		animation-name: breath;
		/* 动画名称 */
		animation-duration: 1s;
		/* 动画时长3秒 */
		animation-timing-function: ease-in-out;
		/* 动画速度曲线：以低速开始和结束 */
		animation-iteration-count: infinite;
		/* 播放次数：无限 */

		/* Safari and Chrome */
		-webkit-animation-name: breath;
		/* 动画名称 */
		-webkit-animation-duration: 1s;
		/* 动画时长3秒 */
		-webkit-animation-timing-function: ease-in-out;
		/* 动画速度曲线：以低速开始和结束 */
		-webkit-animation-iteration-count: infinite;
		/* 播放次数：无限 */
	}

	.starttxt {
		height: 2rem;
		line-height: 2rem;
		position: absolute;
		margin: auto;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		padding-top: 10rem;
		z-index: 2;
		color: #ab7b58;
		font-size: 0.9rem;
	}

	.startbtn {
		width: 8rem;
		height: 8rem;
		display: block;
		position: absolute;
		margin: auto;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		padding-bottom: 2rem;
		z-index: 3;
	}

	audio {
		position: absolute;
		margin: auto;
		left: 0;
		right: 0;
		bottom: 2rem;
		z-index: 99;
	}

	.txtp {
		transition: all 1s;
		opacity: 0;
	}

	.item6 .leftssss a,
	.item6 .leftssss a img,
	.item6 .leftssss a span {
		width: 8rem;
		height: 8rem;
		display: block;
		margin: auto;
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
	}

	.item6 .leftssss {
		display: flex;
		flex-wrap: wrap;
		padding: 1rem;
		height: calc(100% - 2rem);
	}

	.item6 .leftssss a {
		width: 8rem;
		position: relative;
		text-align: center;
		transition: all 1s;
	}

	.item6 .leftssss,
	.item6 .rightssss {
		width: 15rem;
		position: relative;
		transition: all 1s;
		overflow: hidden;
	}

	.item6 .titlessss {
		width: 6rem;
		position: absolute;
		top: 0;
		left: 1rem;
		bottom: 0;
		margin: auto;
	}

	.item6 .ccccc {
		width: calc(100% - 30rem);
		height: 100%;
		display: flex;
	}

	.item6 .ccccc img {
		height: calc(100% - 6rem);
		margin-top: 3rem;
	}

	.item6 .ccccc p {
		writing-mode: horizontal-tb;
		writing-mode: vertical-rl;
		font-family: 'STXingkai';
		font-size: 1.8rem;
		flex: 1;
		line-height: 55.61px;
		margin: 0px auto;
		padding-top: 3.5rem;
		padding-bottom: 3.5rem;
		text-align: left;
		color: #884c32;
	}

	.item6 .ccccc p span {
		font-size: 1.45rem;
		font-weight: bold;
	}

	.item6 {
		background: url(../assets/images/item5bag.jpg) no-repeat;
		background-size: 120% auto;
		background-position: left center;
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: 1;
	}

	.item6 .item6box {
		position: absolute;
		z-index: 3;
		left: 1rem;
		top: 7rem;
		right: 1rem;
		bottom: 1rem;
		text-align: center;
	}

	.item6 .logoico {
		position: absolute;
		top: 3rem;
		left: 3rem;
		width: 18rem;
	}

	.item6 .title {
		height: 6rem;
		text-align: center;
	}

	.item6 .title div {
		line-height: 6rem;
		width: calc(6rem * 6.39);
		height: 6rem;
		margin: 0px auto;
		background: url(../assets/images/itemtitlebag.png) no-repeat;
		background-size: 100%;
		font-family: 'STXingkai';
		font-size: 3rem;
		color: #FFFFFF;
	}

	.item6 .content {
		width: 110rem;
		    height: 55rem;
		    margin: 0px auto;
		    position: relative;
		    margin-top: -3rem;
	}

	.item6 .content .bagsss {
		width: 100%;
	}

	.item6 .contenttext {
		position: absolute;
		top: 13.4rem;
		    left: 11rem;
		    right: 11rem;
		    bottom: 8.4rem;
		background: url(../assets/images/textbag.png) no-repeat;
		background-size: 100% 100%;
		display: flex;
	}

	@keyframes breath {
		from {
			opacity: 0.3;
		}

		/* 动画开始时的不透明度 */
		50% {
			opacity: 1;
		}

		/* 动画50% 时的不透明度 */
		to {
			opacity: 0.3;
		}

		/* 动画结束时的不透明度 */
	}

	@-webkit-keyframes breath {
		from {
			opacity: 0.3;
		}

		/* 动画开始时的不透明度 */
		50% {
			opacity: 1;
		}

		/* 动画50% 时的不透明度 */
		to {
			opacity: 0.3;
		}

		/* 动画结束时的不透明度 */
	}
</style>
